/* eslint-disable jira/filename-case */
import {
	SERVICE_DESK,
	SERVICE_DESK_AUTOMATION_SUB_NAV,
	SERVICE_DESK_ISSUES,
	SERVICE_DESK_ITEMS,
	SERVICE_DESK_KNOWLEDGE_HUB,
	SERVICE_DESK_LANGUAGES,
	SERVICE_DESK_LEGACY_TICKET_TYPES,
	SERVICE_DESK_QUEUES,
	SERVICE_DESK_REPORTS,
	SERVICE_DESK_SETTINGS,
	SERVICE_DESK_TRANSLATIONS,
} from '@jira/servicedesk__common/src/practicesIds.constants.tsx';

const ROOT = 'root/index' as const;
const ISSUES = 'root/issues' as const;
const DASHBOARDS = 'root/dashboards' as const;
const PORTFOLIO = 'root/portfolio' as const;

const WORK_SCRUM = 'work-scrum' as const;
const PLAN_SCRUM = 'plan-scrum' as const;
const WORK_KANBAN = 'work-kanban' as const;
const PLAN_KANBAN = 'plan-kanban' as const;

const PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues' as const;
const PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme' as const;
const PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues' as const;
const PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues' as const;
const PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues' as const;
const PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed' as const;
const PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently' as const;
const PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently' as const;
const PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently' as const;

const AGILITY = 'project/agility/index' as const;
const BUSINESS = 'project/business/index' as const;
const OPS = 'project/ops/index' as const;

const SOFTWARE = 'project/software/index' as const;
const SOFTWARE_ISSUES = 'project/software/issues' as const;
const SOFTWARE_REPORTS = 'project/software/reports' as const;

const USER = 'user/index' as const;
const USER_REPORTS = 'user/reports' as const;

const rootProjectViewIds = {
	AGILITY,
	SERVICE_DESK,
	OPS,
	BUSINESS,
	SOFTWARE,
} as const;

const rootViewIds = {
	ROOT,
	ISSUES,
	DASHBOARDS,
	PORTFOLIO,
} as const;

export const itemIds: {
	readonly SERVICE_DESK: {
		readonly HOME: {
			readonly QUEUES: 'queues';
			readonly ALL_ITSM_QUEUES_SPOTLIGHT: 'all-itsm-queues-spotlight';
			readonly ALL_TICKETS_SPOTLIGHT: 'all-tickets-spotlight';
			readonly TICKET_CATEGORIES_SPOTLIGHT: 'ticket-categories-spotlight';
			readonly SERVICE_REQUEST: 'service-requests';
			readonly INCIDENTS: 'incidents';
			readonly CHANGES: 'changes';
			readonly PROBLEMS: 'problems';
			readonly CUSTOMERS: 'customers';
			readonly POST_INCIDENT_REVIEWS: 'post-incident-reviews';
			readonly REPORTS: 'reports';
			readonly RAISE_REQUEST: 'raise-request';
			readonly ISSUES: 'issues';
			readonly CUSTOMER_CHANNELS: 'customer-channels';
			readonly CUSTOMER_CHANNELS_SPOTLIGHT: 'customer-channels-spotlight';
			readonly JSD_CHANNELS_DIALOG: 'jsd-channels-dialog';
			readonly KNOWLEDGE_BASE: 'knowledge-base';
			readonly KNOWLEDGE_BASE_HUB: 'knowledge-hub';
			readonly KNOWLEDGE_BASE_HUB_NESTED: 'knowledge-hub-nested';
			readonly INVITE_TEAM: 'invite-team';
			readonly GIVE_FEEDBACK: 'give-feedback';
			readonly SERVICES: 'services';
			readonly SERVICES_SPOTLIGHT: 'services-spotlight';
			readonly ALERTS_AND_ON_CALL_SPOTLIGHT: 'alerts-and-on-call-spotlight';
			readonly CHANGE_CALENDAR_SPOTLIGHT: 'change-calendar-spotlight';
		};
		readonly KNOWLEDGE_BASE: {
			readonly TOP_ACTIONS: 'knowledge-hub-top-actions';
			readonly ALL_ARTICLES: 'knowledge-hub-all-articles';
			readonly CATEGORIES: 'knowledge-hub-categories';
			readonly CATEGORIES_CONTEXT: 'knowledge-hub-categories-context';
			readonly BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions';
			readonly ADD_CATEGORY: 'knowledge-hub-new-category';
			readonly LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback';
		};
		readonly SETTINGS: {
			readonly DETAILS: 'details';
			readonly PEOPLE: 'people';
			readonly ITSM_FEATURES: 'itsm-features';
			readonly SUMMARY: 'summary';
			readonly DELETE_PROJECT: 'delete-project';
			readonly ISSUE_TYPES: 'issue-types';
			readonly FEATURES: 'features';
			readonly REQUEST_TYPES: 'sd-request-types';
			readonly TICKET_TYPES: 'sd-ticket-types';
			readonly CUSTOMER_PERMISSIONS: 'sd-customer-permissions';
			readonly LANGUAGE_SUPPORT: 'sd-language-support';
			readonly PORTAL_SETTINGS: 'sd-portal-settings';
			readonly EMAIL_REQUESTS: 'sd-email-requests';
			readonly CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications';
			readonly PROJECT_WIDGET_ADDON: 'sd-project-widget-addon';
			readonly PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer';
			readonly PROJECT_ASSETS_AD: 'sd-project-assets-ad';
			readonly SATISFACTION_SETTINGS: 'sd-satisfaction-settings';
			readonly KNOWLEDGE_BASE: 'sd-knowledge-base';
			readonly SLAS: 'sd-slas';
			readonly AUTOMATION: 'sd-automation';
			readonly PLAYBOOKS: 'playbooks';
			readonly JIRA_AUTOMATION: 'jira-automation';
			readonly AUTOMATION_SUB_NAV: 'sd-automation-sub-nav';
			readonly JSD_INCIDENT_MANAGEMENT: 'sd-incident-management';
			readonly JSD_CHANGE_MANAGEMENT: 'sd-change-management';
			readonly WORKFLOWS: 'workflows';
			readonly SCREENS: 'screens';
			readonly FIELDS: 'fields';
			readonly VERSIONS: 'versions';
			readonly COMPONENTS: 'components';
			readonly PERMISSIONS: 'permissions';
			readonly ISSUE_SECURITY: 'issue-security';
			readonly NOTIFICATIONS: 'notifications';
			readonly HIPCHAT: 'hipchat';
			readonly ISSUE_COLLECTORS: 'issue-collectors';
		};
		readonly QUEUES: {
			readonly QUEUE_NEW: 'queue-new';
			readonly QUEUE_MANAGE: 'queue-manage';
			readonly QUEUES_ADDONS: 'sd-queues-addons';
			readonly QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions';
			readonly SD_QUEUES_CUSTOM: 'sd-queues-custom';
		};
		readonly REPORTS: {
			readonly REPORTS_CUSTOM: 'sd-reports-custom';
			readonly REPORTS_ADDONS: 'sd-reports-addons';
			readonly REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions';
			readonly REPORTS_NAV_TEAM: 'sd-reports-nav-team';
			readonly REPORTS_NAV_KB: 'sd-reports-nav-kb';
		};
	};
	readonly WORK_SCRUM: 'work-scrum';
	readonly PLAN_SCRUM: 'plan-scrum';
	readonly WORK_KANBAN: 'work-kanban';
	readonly PLAN_KANBAN: 'plan-kanban';
	readonly PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: 'pin-filter-myopenissues';
	readonly PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: 'pin-filter-reportedbyme';
	readonly PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: 'pin-filter-allissues';
	readonly PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: 'pin-filter-allopenissues';
	readonly PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: 'pin-filter-doneissues';
	readonly PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: 'pin-filter-recentlyviewed';
	readonly PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: 'pin-filter-addedrecently';
	readonly PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: 'pin-filter-resolvedrecently';
	readonly PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: 'pin-filter-updatedrecently';
} = {
	WORK_SCRUM,
	PLAN_SCRUM,
	WORK_KANBAN,
	PLAN_KANBAN,
	PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
	PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
	...SERVICE_DESK_ITEMS,
} as const;

export const viewIds: {
	readonly SOFTWARE_ISSUES: 'project/software/issues';
	readonly SOFTWARE_REPORTS: 'project/software/reports';
	readonly SERVICE_DESK_ISSUES: 'project/service-desk/issues';
	readonly SERVICE_DESK_QUEUES: 'project/service-desk/queues';
	readonly SERVICE_DESK_REPORTS: 'project/service-desk/reports';
	readonly SERVICE_DESK_SETTINGS: 'project/service-desk/settings';
	readonly SERVICE_DESK_LANGUAGES: 'project/service-desk/languages';
	readonly SERVICE_DESK_LEGACY_TICKET_TYPES: 'project/service-desk/legacy-ticket-types';
	readonly SERVICE_DESK_TRANSLATIONS: 'project/service-desk/translations';
	readonly SERVICE_DESK_AUTOMATION_SUB_NAV: 'project/service-desk/settings/automation-sub-nav';
	readonly SERVICE_DESK_KNOWLEDGE_HUB: 'project/service-desk/knowledge-hub';
	readonly USER: 'user/index';
	readonly USER_REPORTS: 'user/reports';
	readonly AGILITY: 'project/agility/index';
	readonly SERVICE_DESK: 'project/service-desk/index';
	readonly OPS: 'project/ops/index';
	readonly BUSINESS: 'project/business/index';
	readonly SOFTWARE: 'project/software/index';
	readonly ROOT: 'root/index';
	readonly ISSUES: 'root/issues';
	readonly DASHBOARDS: 'root/dashboards';
	readonly PORTFOLIO: 'root/portfolio';
} = {
	...rootViewIds,
	...rootProjectViewIds,
	SOFTWARE_ISSUES,
	SOFTWARE_REPORTS,
	SERVICE_DESK_ISSUES,
	SERVICE_DESK_QUEUES,
	SERVICE_DESK_REPORTS,
	SERVICE_DESK_SETTINGS,
	SERVICE_DESK_LANGUAGES,
	SERVICE_DESK_LEGACY_TICKET_TYPES,
	SERVICE_DESK_TRANSLATIONS,
	SERVICE_DESK_AUTOMATION_SUB_NAV,
	SERVICE_DESK_KNOWLEDGE_HUB,
	USER,
	USER_REPORTS,
} as const;
